import { InputAdornment, TextField } from "@mui/material";
import { MagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { useEffect, useState } from "react";
import { useDebounce } from "../../../lib/Hooks";

interface INewSearchTextBox {
  value: string;
  onChange: (searchTerm: string) => void;
  placeholder?: string;
  width?: string;
}

const NewSearchTextBox = ({ value, onChange, placeholder, width = "300px" }: INewSearchTextBox) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const [prevValue, setPrevValue] = useState(value);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  if (prevValue !== value) {
    setPrevValue(value);
    setSearchTerm(value);
  }

  useEffect(() => {
    onChange(debouncedSearchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <TextField
      sx={{
        fontSize: "28px",
        backgroundColor: "surfaceLight10.main",
        border: "none",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
          },
        },
        borderRadius: "4px",
      }}
      fullWidth
      id="search"
      variant="outlined"
      size="medium"
      value={searchTerm}
      placeholder={placeholder}
      onChange={handleChange}
      data-testid="search-text-box"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <MagnifyingGlassIcon size={20} />
            </InputAdornment>
          ),
          style: { width: width, height: "45px", fontSize: "28px", border: "none" },
        },
      }}
    />
  );
};

export { NewSearchTextBox };
